var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kt-input',{attrs:{"type":"checkbox","data-switch":"true","data-on-color":_vm.variant_on,"data-off-color":_vm.variant_off,"data-size":_vm._size}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }